import React from 'react';
import styled from 'styled-components';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import {
  SmartAccountTitleText,
  maxMobile,
  maxWidth, retina,
} from 'Utils/utilsStyle';

import { Company } from 'Types/CompaniesTypes';
import SelectCompanyModal from 'Components/companyComparison/components/SelectCompanyModal';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  .smart-heading-title-tooltip {
    display: flex;
    width: calc(100% - 15px);
    ${SmartAccountTitleText};
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 16px;
      line-height: 18px;
    }
    @media all and (max-width: ${maxMobile}) {
      font-size: 14px;
      line-height: 16px;
    }
    margin-bottom: 12px;
    .global-tooltip-element {
      position: relative;
      display: inline-flex;
      .section-detail-tip {
        .ant-tooltip {
          left: unset !important;
          right: 25px !important;
          top: 10px !important;
        }
      }
    }
  }
`;

type Props = {
  summary: string,
  tooltipText: string,
  exampleText: string,
  companies: Company[]
};

const SmartCompanyComparison = function SmartCompanyComparison(props: Props) {
  const {
    summary, tooltipText, exampleText, companies,
  } = props;
  return (
    <Wrapper>
      <h1 className="smart-heading-title-tooltip">
        {summary}
        <HeadingWithToolTip
          heightIcon="19px"
          widthIcon="16px"
          heightIconSm="20px"
          widthIconSm="13px"
          customWidth="280px"
          toolTipText={tooltipText}
          exampleText={exampleText}
          toolPlacement="bottomRight"
          midTabletFlag
          htmlFlag
        />
      </h1>
      {companies.length ? companies?.map((company) => (
        <SelectCompanyModal
          smartAccountFlag
          SAPCompany={company}
          SAPCompanies={companies}
        />
      )) : null}
      {Array.from({ length: 3 - companies.length }, (_, index) => (
        <SelectCompanyModal
          key={index}
          smartAccountFlag
          SAPCompanies={companies}
          SAPNoCompetitor
        />
      ))}
    </Wrapper>
  );
};
export default SmartCompanyComparison;
